const resetFields = [
	{
		labelText: 'Adresse Email',
		labelFor: 'email',
		id: 'email',
		name: 'email',
		type: 'email',
		autoComplete: 'email',
		isRequired: true,
		placeholder: 'Adresse Email',
	},
];
const loginFields = [
	{
		labelText: 'Adresse email',
		labelFor: 'email',
		id: 'email',
		name: 'email',
		type: 'email',
		autoComplete: 'email',
		isRequired: true,
		placeholder: 'Adresse email',
	},
	{
		labelText: 'Mot de passe',
		labelFor: 'password',
		id: 'password',
		name: 'password',
		type: 'password',
		autoComplete: 'current-password',
		isRequired: true,
		placeholder: 'Mot de passe',
	},
];

const signupFields = [
	{
		labelText: 'Adresse email',
		labelFor: 'email',
		id: 'email',
		name: 'email',
		type: 'email',
		autoComplete: 'email',
		isRequired: true,
		placeholder: 'Adresse email',
	},
	{
		labelText: 'Mot de passe',
		labelFor: 'password',
		id: 'password',
		name: 'password',
		type: 'password',
		autoComplete: 'current-password',
		isRequired: true,
		placeholder: 'Mot de passe',
	},
	{
		labelText: 'Confirmer le Mot de passe',
		labelFor: 'confirm_password',
		id: 'confirm_password',
		name: 'confirm_password',
		type: 'password',
		autoComplete: 'confirm_password',
		isRequired: true,
		placeholder: 'Confirmer le Mot de passe',
	},
	{
		labelText: 'Numéro de téléphone',
		labelFor: 'phone_number',
		id: 'phone_number',
		name: 'phone_number',
		type: 'tel',
		autoComplete: 'tel',
		isRequired: true,
		placeholder: 'Numéro de téléphone',
	},
	{
		labelText: 'Role',
        labelFor: 'role',
        id: 'role',
        name: 'role',
        type: 'select',
        autoComplete: 'role',
        isRequired: true,
        placeholder: 'Role',
	}
];

export { loginFields, signupFields, resetFields };
